export default "__VITE_ASSET__4C717KSA__"